<template>
  <div>
    <div class='main'>
      <MainHeader
        @reloadMainPage="reloadMainPage()"
        @allMenuToggleEmit="allMenuToggleChange"
      />
      <div id='container'>
        <!-- <div class="onnuriMarket" v-if="stores[this.currentStoreCode].serviceType">
          <div class="img"></div>
        </div> -->
        <!-- 오늘의 상품 -->
        <TodayMenuContainer/>
        <!-- 가맹점 정보 -->
        <!-- TODO : 2025-12-10 명동 포장 관련 임시, 아래 v-if 조건만 삭제 -->
        <div class="merchantInformationWrap" v-if="!isTakeOutStoreIncluded(this.currentStoreCode)">
          <div class="merchantInformationTop">
            <div class="d-flex">
              <a href="javascript:void(0)" class="button-detail" @click.prevent="goMerchant">
                {{$t('MainPage.merchantInformation')}}ㆍ{{$t('MainPage.deliveryInformation')}}
                <img src="@/assets/img/ic-arrow-s.svg" alt="">
              </a>
              <div v-if="this.companyType != 5 && this.appFlag" class="likeWrap">
                <span v-if="likeFlag == 2"></span>
                <span class="btn_like_active" v-else-if="likeFlag == 1"></span>
                <span class="btn_unlike_active" v-else></span>
              </div>
            </div>
            <div class="merchantInfo" v-if="orderType.includes(3)">
              <div class="merchantInfoTit">{{$t('MainPage.deliveryFee')}}</div>
              <div v-if="deliveryFee.from == 0 & deliveryFee.to == 0" style="display: flex;">
                <span class="appStTag freeTag">{{$t('free')}}</span>
              </div>
              <div v-else-if="freeMemberShipFlag" style="display: flex;">
                <span class="fwb" style="text-decoration: line-through; color: #f119a9">{{formatComma(deliveryFee.from)}}{{$t('MoneyUnit')}}<br></span>
                <span class="appStTag freeTag" style=" margin-left: 5px">{{$t('free')}}</span>
              </div>
              <div v-else-if="deliveryFee.from == deliveryFee.to">
                <span class="fwb">{{formatComma(deliveryFee.from)}}{{$t('MoneyUnit')}} {{$t('MainPage.dependingOnDistance')}}<br></span>
              </div>
              <div v-else>
                <span class="fwb">{{formatComma(deliveryFee.from)}}{{$t('MoneyUnit')}} ~ {{formatComma(deliveryFee.to)}}{{$t('MoneyUnit')}}<br></span>
                {{$t('MainPage.dependingOnDistance')}}
              </div>
            </div>
            <div class="merchantInfo">
              ㆍ
            </div>
            <div class="merchantInfo" v-if="orderType.includes(3)">
              <div class="merchantInfoTit">{{$t('MainPage.minimumCost')}}</div>
              <div class="fwb" v-if="this.riderInfo">
                {{formatComma(this.riderInfo.minOrderFee)}}{{$t('MoneyUnit')}}
              </div>
            </div>
          </div>
          <div class="merchantInformationBot" v-if="merchantFlag">
            <ul>
              <li>
                <span>{{$t('MainPage.storeName')}}</span>
                <p>{{this.storeInfo.name}}</p>
              </li>
              <li v-if="this.storeInfo.marketName">
                <span>{{$t('marketAffiliation')}}}</span>
                <pre>{{this.storeInfo.marketName}}</pre>
              </li>
              <li v-if="this.storeInfo.opTimeDesc">
                <span>{{$t('MainPage.businessHours')}}</span>
                <pre>{{this.storeInfo.opTimeDesc}}</pre>
              </li>
              <li v-if="this.storeInfo.holidayDesc">
                <span>{{$t('MainPage.closeDays')}}</span>
                <pre>{{this.storeInfo.holidayDesc}}</pre>
              </li>
              <li>
                <span>{{$t('MainPage.address')}}</span>
                <p>{{this.storeInfo.address}}</p>
              </li>
              <li style="margin-top: 11px">
                <span style="margin-top: 5px">{{$t('MainPage.phoneNumber')}}</span>
                <ul class="merchantInfoNumber">
                  <li>
                    <p>{{getPhoneNo(this.storeInfo.phone)}}</p>
                    <a :href='"tel:" + this.storeInfo.phone' class='merchantInfoCall'></a>
                  </li>
                </ul>
              </li>
              <li v-if="this.storeInfo.deliveryArea" style="margin-top: 11px">
                <span v-if="this.companyType==5">{{$t('MainPage.shoppingDeliveryAvailableArea')}}</span>
                <span v-else>{{$t('MainPage.deliveryAvailableArea')}}</span>
                <p v-if="$i18n.locale==='ko'">{{this.storeInfo.deliveryArea}}</p>
                <p v-else-if="$i18n.locale==='en'">{{this.storeInfo.deliveryAreaEn}}</p>
                <p v-else-if="$i18n.locale==='cn'">{{this.storeInfo.deliveryAreaCn}}</p>
              </li>
              <li v-if="this.storeInfo.deliveryFreeAmount">
                <span>{{$t('amountForFreeDelivery')}}</span>
                <p>{{formatComma(this.storeInfo.deliveryFreeAmount) + $t('MoneyUnit')}}</p>
              </li>
              <li v-if="this.storeInfo.deliveryAreaList" class="table">
                <span>{{ $t('additionalDeliveryFeeByRegion') }}</span>
                <table class="custom-table">
                  <tr v-for="(item,index) in storeInfo.deliveryAreaList" :key="index">
                    <td>{{ item.area.join(', ') }}</td>
                    <td>+{{ formatComma(item.extraFee) }}{{$t('MoneyUnit')}}</td>
                  </tr>
                </table>
              </li>
            </ul>
          </div>
        </div>
        <!-- TODO : 2025-12-10 명동 포장 관련 임시, 아래 v-else div 전체삭제-->
        <div class="merchantInformationWrap" v-else>
          <!-- 여기 수정 해야 한다 -->
          <div class="merchantInformationTop">
            <div class="d-flex">
              <a href="#" class="button-detail" @click.prevent="goMerchant">
                {{$t('MainPage.merchantInformation')}}ㆍ{{$t('MainPage.pickUpInformation')}}
                <img src="../assets/img/ic-arrow-s.svg" >
              </a>
            </div>
            <div class="merchantInfo">
              <div class="merchantInfoTit">{{ $t('pickupOnlyStore') }}</div>
            </div>
          </div>
        </div>
        <!-- 상품리스트 -->
        <MainMenuContainer :pageEndFlag='lastPageFlag' :companyType="companyType"/>
      </div>
      <MainFooter @showCart='showCart' :companyType="companyType" :cartInfo.sync="cartInfo" :appTotalPrice="totalPrice"/>
      <CartPopUp :cartStoreCode="cartStoreCode" :cart='cart' :cartInfo.sync="cartInfo" :cartMinOrderFee="cartMinOrderFee" :extraMenu='extraMenu'  @cartList="cartList" :appTotalPrice="totalPrice" :qrType="qrType" :marketName="marketName" :cartStoreName="cartStoreName" @cartFlagChange="cartFlagChange"/> <!-- 카트 PopUp -->
      <SimpleMenuDetailPopUp v-if='!fullVUi' @setExtraMenu='setExtraMenu'/> <!-- simple 버전 상품 상세 pop up -->
      <AppAllMenuPopup
        v-if="allMenuToggle"
        @allMenuToggleEmit="allMenuToggleChange"
        @pwdToggleChange="pwdToggleChange"
      />
      <SingleBtnDialog
        v-if='showSingleBtnDialogFlag'
        :messageType='singleBtnMsgType'
        :onClickConfirmBtn='onClickConfirmBtn'/>
      <AppChangePassword
        v-if="pwdToggle"
        @pwdToggleChange="pwdToggleChange"
        @showSingleBtnDialog="showSingleBtnDialog"
        class="pop-top"
      />
    </div>
  </div>

</template>
<script>
import MainHeader from '@/components/Header/MainHeader'
import MainFooter from '@/components/Footer/MainFooter'
import TodayMenuContainer from '@/components/MainPage/TodayMenuContainer'
import MainMenuContainer from '@/components/MainPage/MainMenuContainer'
import CartPopUp from '@/components/PopUp/CartPopUp'
import AppChangePassword from '@/views/AppChangePassword.vue'
import SimpleMenuDetailPopUp from '@/components/PopUp/SimpleMenuDetailPopUp'
import SingleBtnDialog from '@/components/Dialog/SingleBtnDialog.vue'
import { FRANCHISE_DETAIL_NAME, INTRO_PAGE_NAME, MAIN_PAGE_NAME } from '@/utils/EndPoint'
import { REQ_MAIN_INDEX, SET_CART_TYPE, REQ_MENU_LIST, REQ_STORE_INFO, SET_DIRECTFLAG, INIT_DELIVERY_FEE, SET_OPEN_AREA_DELIVERY_ABLE_INFO } from '@/store/_actions/actionTypes'
import { THROW_ERROR } from '@/router'
import { BACKEND_ERROR_MESSAGE, MSG_DISABLE_DELIVERY } from '@/utils/Message'
import service from '@/backend/modnpay_app_api'
// TODO : 2025-12-10 명동 포장 관련 임시 , import TakeOutStore from '@/utils/TakeOutStore' 추가로 mixins 부분 삭제
import TakeOutStore from '@/utils/TakeOutStore'

import CloneDeep from 'lodash'

export default {
  name: MAIN_PAGE_NAME,
  mixins: [TakeOutStore],
  // props: ['pageEndFlag', 'from'],
  components: {
    MainHeader, // Header
    MainFooter, // Footer
    TodayMenuContainer, // 오늘의 상품
    MainMenuContainer, // 상품리스트
    CartPopUp, // 카트 PopUp
    SimpleMenuDetailPopUp, // Simple Version 상품 상세 Popup
    SingleBtnDialog, // 배달불가능 alert dialog
    AppChangePassword
  },
  data () {
    return {
      pageEndFlag: true,
      from: INTRO_PAGE_NAME,
      miniFlag: false,
      freeMemberShipFlag: sessionStorage.getItem('freeMemberShipFlag') === 1,
      appUserCode: localStorage.getItem('appUserCode'),
      cartInfo: {},
      merchantFlag: false,
      lastPageFlag: true,
      extraMenu: undefined,
      fullVUi: this.$store.getters.fullVUi,
      showSingleBtnDialogFlag: false, // single btn dialog show flag
      singleBtnMsgType: MSG_DISABLE_DELIVERY, // 배달불가 alert dialog message type
      ableDeliveryFlag: this.$store.getters.ableDeliveryFlag, // 배달불가 여부 alert
      storeCode: '',
      totalPrice: '',

      cart: undefined,
      cartStoreName: '',
      cartFlag: false,
      cartStoreCode: '',
      marketName: '',
      qrType: '',
      cartMinOrderFee: '',
      pwdToggle: false, // 비밀번호 변경 팝업
      address: ''
    }
  },
  computed: {
    stores () { return this.$store.getters.stores },
    currentStoreCode () { return this.$store.getters.currentStoreCode },
    likeFlag () { return this.$store.getters.likeFlag },
    companyType () { return this.$store.getters.companyType },
    orderType () { return this.$store.getters.orderMethodType },
    originCart () { return this.$store.getters.cart },
    storeInfo () { return this.$store.getters.storeInfo },
    menus () { return this.$store.getters.menus },
    riderInfo () { return this.$store.getters.riderInfo }, // 배달비 정보
    deliveryFee () { return this.$store.getters.deliveryFee }
  },
  created () {
    const { pageEndFlag, from } = this.$route.params || {}
    this.pageEndFlag = pageEndFlag !== undefined ? pageEndFlag : true
    this.from = from !== undefined ? from : INTRO_PAGE_NAME
    // deliveryFee가 falsy일떄 객체 초기화, 배달비 시작, 종료 0원으로 설정
    if (!this.deliveryFee) {
      this.$store.commit(INIT_DELIVERY_FEE)
    }
  },
  mounted () {
    window.backBtn = () => {
      if (this.cartFlag) {
        this.removePopUp()
        this.cartFlagChange()
      } else if (this.pwdToggle) {
        this.pwdToggle = !this.pwdToggle
      } else if (this.allMenuToggle) {
        this.allMenuToggleChange()
      } else {
        if (sessionStorage.getItem('openAreaAccept')) {
          this.$router.push({ name: 'OpenAreaStoreList' })
        } else if (sessionStorage.getItem('categoryCode') || sessionStorage.getItem('tradition')) {
          this.$router.push({ name: 'AppStoreList' })
        } else {
          this.appMoveMain()
        }
      }
    }

    const from = this.$route.query.from
    if (typeof from !== 'undefined') {
      this.from = from
    }

    this.address = sessionStorage.getItem('selectAddress')

    this.$store.dispatch(SET_DIRECTFLAG, false)
    if (window.__wxjs_environment === 'miniprogram') {
      this.$i18n.locale = 'cn'
      document.title = 'MODNPAY智慧点餐'
      this.miniFlag = true
    }
    this.moveToOnTabNoAni()
    sessionStorage.setItem('fullVUi', this.$store.getters.fullVUi)
    if (this.appFlag) {
      this.cartList()
    } else {
      // CartPopUp에서 qrType, cartStoreCode를 요청 데이터로 하여 가맹점 QR URL 조회 API 요청 시 사용
      // cartList()는 앱(appFlag=true)일 때만 호출되므로, 단순 QR scan을 통한 경우를 위한 설정
      this.qrType = this.$store.getters.qrType
      this.cartStoreCode = this.currentStoreCode
    }
    this.selectTakeOutList()
    if (this.appFlag) {
      this.selectDeliveryInfo()
    }

    this.initPage()
  },
  methods: {
    showSingleBtnDialog (message) {
      this.singleBtnMsgType = message
      this.onClickConfirmBtn = () => {
        this.pwdToggleChange()
        this.showSingleBtnDialogFlag = false
      }
      this.showSingleBtnDialogFlag = true
    },
    pwdToggleChange () {
      this.pwdToggle = !this.pwdToggle
    },
    async cartList () {
      const req = {}

      const { data } = await service.appCartList(req)
      if (data.resultCode === 0) {
        this.qrType = data.qrType
        this.totalPrice = data.totalPrice
        this.cartStoreName = data.storeName
        this.cartMinOrderFee = data.minOrderFee
        this.cartStoreCode = data.storeGroupCode
        this.marketName = data.marketName
        this.cartInfo = data.cartList.map(item => {
          const parsedCartInfo = JSON.parse(item.cartInfo)
          const appCartId = item.appCartId
          const price = item.price
          const count = item.count
          return {
            ...parsedCartInfo,
            appCartId,
            price,
            count
          }
        })
      } else if (data.resultCode === 20001) {
        this.cartInfo = {}
      }
    },
    merchantFlagChange () {
      this.merchantFlag = !this.merchantFlag
      this.storeCode = this.$store.getters.storeCode
      this.$store.dispatch(REQ_STORE_INFO)
    },
    reloadMainPage () {
      this.$store.dispatch(REQ_MAIN_INDEX)
        .then(() => {
          // mutation에서 첫번째 카테고리와 현재 카테고리 맞지않으면 호출을 메인 response 호출후
          // 검사후 호출로 변경 callBack으로 꺼낸 후 현재 pageEndFlag를 통해 스크롤 작동을 결정하기 위하여
          // author beomshin modify_beom_1
          const firstCategoryCode = this.$store.getters.categories[0].code
          const curCagtegory = this.$store.getters.currentCategoryCode
          if (firstCategoryCode !== curCagtegory) {
            this.$store.dispatch(REQ_MENU_LIST, { categoryCode: curCagtegory, pageNumber: 1 })
              .then((res) => {
                this.lastPageFlag = res.pageEndFlag
              })
          }
        })
        .catch((error) => {
          const resultCode = error.data.resultCode
          THROW_ERROR(true, BACKEND_ERROR_MESSAGE, 'S:' + resultCode)
        })
    },
    initPage () {
      if (!!this.from && (this.from !== INTRO_PAGE_NAME)) {
        this.$store.dispatch(REQ_MAIN_INDEX)
          .then(() => {
            // mutation에서 첫번째 카테고리와 현재 카테고리 맞지않으면 호출을 메인 response 호출후
            // 검사후 호출로 변경 callBack으로 꺼낸 후 현재 pageEndFlag를 통해 스크롤 작동을 결정하기 위하여
            // author beomshin modify_beom_1
            const firstCategoryCode = this.$store.getters.categories[0].code
            const currentCategoryCode = this.$store.getters.currentCategoryCode
            if (firstCategoryCode !== currentCategoryCode) {
              this.$store.dispatch(REQ_MENU_LIST, { categoryCode: currentCategoryCode, pageNumber: 1 })
                .then((res) => {
                  this.lastPageFlag = res.pageEndFlag
                })
            }
          })
          .catch((error) => {
            const resultCode = error.data.resultCode
            THROW_ERROR(true, BACKEND_ERROR_MESSAGE, 'S:' + resultCode)
          })
      } else { // 인트로 화면에서 들어온 경우
        this.lastPageFlag = this.pageEndFlag
        if (!this.ableDeliveryFlag) { // 배달이 불가능할 경우
          this.showSingleBtnDialogFlag = true
        }
      }
      // 초기 카트 깊게 복사
      this.cart = this.originCart
    },
    setExtraMenu (extraMenu) {
      this.cart = CloneDeep.cloneDeep(this.originCart)
      this.extraMenu = extraMenu
      this.createPopUp('#cart.cusLayer')
    },
    // simple 버전에서 카트에 상품 추가
    cartFlagChange () {
      this.cartFlag = !this.cartFlag
    },
    showCart () {
      this.cartFlagChange()
      this.cart = this.originCart
      this.$store.dispatch(SET_CART_TYPE, true).then(() => this.createPopUp('#cart.cusLayer'))
    },
    onClickConfirmBtn () { this.showSingleBtnDialogFlag = false },
    goMerchant () {
      this.$router.push({ name: FRANCHISE_DETAIL_NAME })
    },
    async selectTakeOutList () {
      const req = {}
      const { data } = await service.takeOutList(req)
      if (data.resultCode === 0) { // 성공 시
        let takeOutStoreList = []
        if (data && data.takeOutList) {
          takeOutStoreList = Array.isArray(data.takeOutList) ? data.takeOutList : []
        }
        this.setTakeOutStoreList(takeOutStoreList)
      }
    },
    async selectDeliveryInfo () {
      const userAddress = sessionStorage.getItem('selectAddress')
      const parseAddress = JSON.parse(userAddress)

      console.log('userAddress : ', userAddress)
      console.log('parseAddress : ', parseAddress)

      const req = {
        storeGroupCode: this.currentStoreCode,
        townshipCode: this.appFlag ? parseAddress?.townshipCode : parseAddress.admCd,
        gpsX: typeof parseAddress.x !== 'undefined' ? parseAddress.x : parseAddress.gpsX,
        gpsY: typeof parseAddress.y !== 'undefined' ? parseAddress.y : parseAddress.gpsY
      }

      const { data } = await service.deliveryInfo(req)
      if (data.resultCode === 0) {
        this.$store.commit(SET_OPEN_AREA_DELIVERY_ABLE_INFO, data?.deliveryInfo?.isDeliveryAble !== 'N')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.merchantInfoTit{
  min-width: 0;
  margin-right: 8px;
}

.merchantInformationTop{
  display: flex;
  flex-wrap:wrap;
}

.merchantInfo{
  padding-bottom: 0;
}

.button-detail{
  border: 1px solid #d9d9d9;
  padding: 4px 10px;
  border-radius: 14px;
  display: flex;
  img{
    margin-left: 4px;
  }
}

.d-flex{
  display: flex;
  flex: 1 1 100%;
  justify-content: space-between;
  margin-bottom: 8px;
}

</style>
